export default {
    // texto
    text: {
        brand: process.env.VUE_APP_BRAND_NAME,
        /**
         *
         * @param {string} pre - Verifica se há o uso da preposição "a"
         * @returns
         */
        brandWithArtigo: (pre = '') => {
            const [brand, artigo] = [process.env.VUE_APP_BRAND_NAME, process.env.VUE_APP_ARTIGO]
            if (pre == artigo) return pre.concat(` ${brand}`)
            return `${pre}${artigo}`.concat(` ${brand}`)
        },
        subscriptionPrefix: process.env.VUE_APP_SUBSCRIPTION_PREFIX,
        savingsDashboardTitle: process.env.VUE_APP_SAVINGS_DASHBOARD_TITLE || 'Poupança',
        supportMessage: process.env.VUE_APP_SUPPORT_MESSAGE || 'Olá!',
    },

    // hide screens
    hideScreens: {
        hideScreenEducational: process.env.VUE_APP_HIDE_SCREEN_EDUCATIONAL === 'true',
        hideScreenSpecialists: process.env.VUE_APP_HIDE_SCREEN_SPECIALISTS === 'true',
        hideScreenTasks: process.env.VUE_APP_HIDE_SCREEN_TASKS === 'true',
        hideScreenProducts: process.env.VUE_APP_HIDE_SCREEN_PRODUCTS === 'true',
        hideScreenAppointments: process.env.VUE_APP_HIDE_SCREEN_APPOINTMENTS === 'true',
        hideScreenSignUp: process.env.VUE_APP_HIDE_SIGN_UP === 'true',
        hideScreenCalendar: process.env.VUE_APP_HIDE_CALENDAR === 'true',
    },

    // hide subscreens
    hideSubscreens: {
        hideSubscreenProfile: process.env.VUE_APP_HIDE_SUBSCREEN_PROFILE == 'true',
    },

    // features
    features: {
        lockBankConnection: process.env.VUE_APP_LOCK_BANK_CONNECTION === 'true',
        lockRecoverPassword: process.env.VUE_APP_LOCK_RECOVER_PASSWORD === 'true',
        disableGenderEdition: process.env.VUE_APP_DISABLE_EDIT_GENDER === 'true',
        unlockEducationTrails: process.env.VUE_APP_DISABLE_UNLOCK_EDUCATIONAL_TRAILS === 'true',
    },

    // subtitles
    subtitles: {
        sidebarTitles: JSON.parse(process.env.VUE_APP_SIDEBAR_TITLES || '{}'),
        screenTitles: JSON.parse(process.env.VUE_APP_SCREEN_TITLES || '{}'),
    },

    // colors
    colors: {
        expensesColor: process.env.VUE_APP_EXPENSES,
    },

    // imagens
    imgs: {
        logo: require(process.env.VUE_APP_LOGO),
        logoSmartphone: require(process.env.VUE_APP_LOGO_SMARTPHONE),
        brandIcon: require(process.env.VUE_APP_BRAND),
        brandIcon2: require('../assets/img/brand_2.png'),
        background: require(process.env.VUE_APP_BACKGROUND_BG),
        chatIcon: require(process.env.VUE_APP_CHAT_ICON),
        listIcon: require(process.env.VUE_APP_LIST_ICON),
        placeholder: require(process.env.VUE_APP_PLACEHOLDER_IMG),
    },

    // config
    config: {
        socialLoginEnabled: process.env.VUE_APP_SOCIAL_LOGIN_ENABLED === 'true',
        facebookLoginEnabled: process.env.VUE_APP_FACEBOOK_LOGIN_ENABLED === 'true',
        googleLoginEnabled: process.env.VUE_APP_GOOGLE_LOGIN_ENABLED === 'true',
        appleLoginEnabled: process.env.VUE_APP_APPLE_LOGIN_ENABLED === 'true',
        version: process.env.VUE_APP_VERSION,
        host: process.env.VUE_APP_HOST_URL,
        disableSidebarAnimation: process.env.VUE_APP_DISABLED_SIDEBAR_ANIMATION === 'true',
        loginWithTerms: process.env.VUE_APP_LOGIN_WITH_TERMS,
    },

    // profile subscreen
    profileSubscreen: {
        hideEmail: process.env.VUE_APP_HIDE_EMAIL === 'true',
    },

    // tutorial
    tutorial: {
        disableBasicTutorial: process.env.VUE_APP_DISABLE_BASIC_TUTORIAL === 'true',
    },

    // links
    links: {
        usageTerms: process.env.VUE_APP_USAGE_TERMS,
        privatePolicy: process.env.VUE_APP_PRIVATE_POLICY,
        contactPhone: process.env.VUE_APP_CONTACT_PHONE,
        appointmentsWebsiteLink: process.env.VUE_APP_APPOINTMENTS_WEBSITE,
    },
}
